import contextMenuFactory from '@/modules/clinicalModule/views/grid/contextMenuFactory'
import PatientResource from '@/api/resources/PatientResource'
import clinicalRequestService from '@/modules/clinicalModule/services/clinicalRequestService'
import { getRequestDeletionConfirmationMessage } from '@/api/resources/ConfirmationMessageResource'
import clinicalRequestPrintService from '@/modules/printModule/services/ClinicalRequestPrintService'
import clinicalCasePrintService from '@/modules/printModule/services/ClinicalCasePrintService'

export default {
    methods: {
        getContextMenuItems(params) {
            if (params?.node) {
                const studyRequest = params.node.data
                return contextMenuFactory.getMenuItems(params, {
                    create: () => this.createRequest(studyRequest.patient.id),
                    edit: () => this.editRequest(studyRequest.laboratory.labId, studyRequest.id),
                    cancel: () => this.cancelRequestConfirmation([studyRequest]),
                    discard: () => this.deleteDraftRequestConfirmation([studyRequest]),
                    addFile: () => this.showAddFileModal(studyRequest),
                    printReport: () => this.printRequestReport(studyRequest),
                    printLabels: () => this.printSubrequestContextMenu(studyRequest),
                    printReportAndLabels: () => this.printReportAndLabels(studyRequest),
                    printCaseReport: () => this.printCaseReport(studyRequest),
                    exportAllToExcel: () => this.exportAllToExcel(params),
                    batchCancel: () => this.cancelRequestConfirmation(params.api.getSelectedRows()),
                    batchDiscard: () => this.deleteDraftRequestConfirmation(params.api.getSelectedRows()),
                    batchPrintReport: () => this.batchPrintReport(params.api.getSelectedRows()),
                    batchPrintLabels: () => this.batchPrintLabels(params.api.getSelectedRows()),
                    batchPrintReportAndLabels: () => this.batchPrintReportAndLabels(params.api.getSelectedRows()),
                    batchPrintCaseReport: () => this.batchPrintCaseReport(params.api.getSelectedRows()),
                    batchExcelExport: () => this.exportToExcel(params, { onlySelectedAllPages: true })
                })
            }
            return []
        },
        async exportToExcel(params, options) {
            params.api.exportDataAsExcel({
                fileName: this.$tc('global.requests'),
                rowHeight: 20,
                processCellCallback: ({ column, value }) => {
                    if (column.colId === 'status') {
                        return value.name
                    }
                    if (column.colId === 'level') {
                        const priority = this.sessionState.priorities.find(p => p.level === value)
                        return priority.name
                    }
                    if (value === true) {
                        return this.$tc('global.yes')
                    }
                    if (value === false) {
                        return this.$tc('global.no')
                    }
                    return value
                },
                ...options
            })
        },
        batchPrintCaseReport(studyRequests) {
            clinicalCasePrintService.getCaseAPReports(studyRequests.map(i => i.id))
        },
        batchPrintReportAndLabels(studyRequests) {
            this.batchPrintReport(studyRequests)
            studyRequests.forEach(subrequest => this.printLabels(subrequest))
        },
        batchPrintReport(studyRequests) {
            clinicalRequestPrintService.getRequestReportPdfForPrinting(studyRequests.map(i => i.id))
        },
        batchPrintLabels(studyRequests) {
            studyRequests.forEach(subrequest => this.printLabels(subrequest))
        },
        async exportAllToExcel(params) {
            const first = params.api.paginationGetCurrentPage() * params.api.paginationGetPageSize()
            const last = first + params.api.paginationGetPageSize() - 1
            await this.exportToExcel(params, {
                shouldRowBeSkipped: ({ node }) => {
                    return node.rowIndex < first || node.rowIndex > last
                }
            })
        },
        async printReportAndLabels(studyRequest) {
            // TODO Check unsaved changes
            this.printRequestReport(studyRequest)
            this.printSubrequestContextMenu(studyRequest)
            // TODO Add request reload
        },
        async printCaseReport(studyRequest) {
            let includeAssociated = false
            if (studyRequest.caseStudy?.hasCaseStudiesAssociated) {
                includeAssociated = await this.showConfirmationModalGlobal(this.$tc('global.modal.case.viewAssociatedCasesConfirmation'))
            }
            let caseStudy = {
                casId: studyRequest.caseStudy.casId,
                labId: studyRequest.laboratory.labId
            }
            await this.$refs.printComponent.printCaseReportFromClinical(caseStudy, includeAssociated)
        },
        async printSubrequestContextMenu(request) {
            const requestComplete = await clinicalRequestService.get(request.laboratory.labId, request.id)
            await this.printSubrequestLabels(requestComplete)
        },
        async printSubrequestLabels(request) {
            // TODO Check unsaved changes
            // TODO This inline if must be removed when current method receives laboratoryId as parameter instead of as attribute in objects.
            const laboratoryId = request.laboratoryLabId ? request.laboratoryLabId : request.laboratory.labId
            await this.$refs.printComponent.printSubrequestReportFromClinical(laboratoryId, request.id, request.subrequests)
            // TODO Add request reload
        },
        async printRequestReport(request) {
            await this.$refs.printComponent.printRequestReportFromClinical(request)
        },
        showAddFileModal(studyRequest) {
            this.entitiesIdArray = [studyRequest.laboratory.labId, studyRequest.id]
            this.$refs.addFileModalWrapper.show()
        },
        async createRequest(patId) {
            const patient = await PatientResource.findById(patId)
            this.$router.push({ name: 'newRequest', params: { initPatient: patient } })
        },
        editRequest(labId, requestId) {
            this.$router.push({ name: 'editRequest', params: { labId: labId, requestId: requestId } })
        },
        cancelRequestConfirmation(selectedStudyRequests) {
            this.nameModal = 'cancelRequestConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.modalConfirmationMessage = this.$t('component.modalConfirmation.content')
                this.$nextTick(() => {
                    this.askConfirmation(() => this.cancelStudyRequests(selectedStudyRequests))
                })
            } else {
                this.cancelStudyRequests(selectedStudyRequests)
            }
        },
        async cancelStudyRequests(studyRequests) {
            this.updateLoading(true)
            const [err] = await this.toCall(clinicalRequestService.batchCancel(studyRequests.map(sr => sr.id)))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.showSuccessModalGlobal(this.$t('studyRequest.info.requestsCanceled'))
            this.showSidePanel = false
            this.selectedStudyRequest = null
            this.reloadRowData()
        },
        getModalConfirmationState(modalName) {
            return this.$_getModalConfirmationState('clinicalModalsState', modalName)
        },
        askConfirmation(action) {
            this.$refs.confirmationModal.show(action)
        },
        deleteDraftRequestConfirmation(selectedStudyRequests) {
            this.nameModal = 'deleteDraftRequestConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.modalConfirmationMessage = this.$t(getRequestDeletionConfirmationMessage(selectedStudyRequests))
                this.$nextTick(() => {
                    this.askConfirmation(() => this.deleteStudyRequests(selectedStudyRequests))
                })
            } else {
                this.deleteStudyRequests(selectedStudyRequests)
            }
        },
        async deleteStudyRequests(studyRequests) {
            this.updateLoading(true)
            const [err] = await this.toCall(clinicalRequestService.batchDiscard(studyRequests.map(sr => sr.id)))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal(this.$t('studyRequest.error.requestDeletionFailed'))
            } else {
                this.showSuccessModalGlobal(this.$t('studyRequest.info.requestsDeleted'))
                this.showSidePanel = false
                this.selectedStudyRequest = null
                this.$emit('loadSummary')
                this.reloadRowData()
            }
            this.modalConfirmationMessage = ''
        }
    }
}
